module.exports = __webpack_public_path__ + "static/remove_access_confirmation-ca540ab6b61919be0dd18e869d4173f5.png";